<script>
import { mapActions } from 'vuex';

import Tabs from '@/components/elements/Tabs';
import TableView from '@/components/elements/views/TableView';

export default {
    components: {
        Tabs
    },

    page: {
        title: 'Volunteer Emails'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Volunteer Emails',
            includeDeleteAction: false
        };
    },

    computed: {
        labels() {
            return [{ value: 'email' }];
        },

        options() {
            return {
                filters: true,
                addButton: false
            };
        }
    },

    methods: {
        ...mapActions({
            getItems: 'volunteerEmails/index'
        })
    }
};
</script>
